import { useMemo, useState } from "react";
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

const SCORE = { super: 5, gut: 4, okay: 3, muede: 2, traurig: 1 };
const NAME = ["", "Traurig", "Müde", "Okay", "Gut", "Super"];
const COLOR = ["", "#94a3b8", "#7dd3fc", "#fcd34d", "#f472b6", "#f43f5e"];
const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function MoodChart({ diary }) {
  const [range, setRange] = useState(7);
  const data = useMemo(() => {
    const by = Object.fromEntries(diary.map((x) => [x.date, SCORE[x.mood]]));
    return Array.from({ length: range }, (_, i) => {
      const d = new Date(); d.setDate(d.getDate() - (range - 1 - i));
      return { day: d.toLocaleDateString("de-DE", range === 7 ? { weekday: "short" } : { day: "2-digit", month: "2-digit" }), v: by[iso(d)] || 0 };
    });
  }, [diary, range]);
  const vals = data.filter((x) => x.v);
  const avg = vals.length ? vals.reduce((a, x) => a + x.v, 0) / vals.length : 0;
  return (
    <div className="bg-white rounded-3xl border border-pink-100 p-5 sm:p-6 space-y-3" data-testid="mood-chart">
      <div className="flex items-center justify-between gap-2">
        <h2 className="font-display text-xl font-extrabold">Mein Stimmungs-Verlauf</h2>
        <div className="flex rounded-full bg-rose-50 p-1">
          {[[7, "Woche"], [30, "Monat"]].map(([r, l]) => <button key={r} onClick={() => setRange(r)} data-testid={`mood-chart-${r}`} aria-pressed={range === r} className={`px-3 h-8 rounded-full text-xs font-bold transition-colors ${range === r ? "bg-white text-rose-600 shadow-sm" : "text-slate-500"}`}>{l}</button>)}
        </div>
      </div>
      <p className="text-sm text-slate-500" data-testid="mood-chart-avg">{vals.length ? <>Durchschnitt: <b className="text-rose-600">{NAME[Math.round(avg)]}</b> an {vals.length} von {range} Tagen</> : "Noch keine Einträge in diesem Zeitraum."}</p>
      <div className="h-48">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 0, left: 0, bottom: 0 }}>
            <XAxis dataKey="day" tick={{ fontSize: 10, fill: "#94a3b8" }} interval={range === 7 ? 0 : 4} axisLine={false} tickLine={false} />
            <YAxis domain={[0, 5]} ticks={[1, 3, 5]} width={48} tickFormatter={(v) => NAME[v]} tick={{ fontSize: 10, fill: "#94a3b8" }} axisLine={false} tickLine={false} />
            <Tooltip cursor={{ fill: "#fff1f2" }} formatter={(v) => [NAME[v] || "–", "Stimmung"]} contentStyle={{ borderRadius: 12, border: "1px solid #fce7f3", fontSize: 12 }} />
            <Bar dataKey="v" radius={[8, 8, 8, 8]} isAnimationActive>{data.map((x, i) => <Cell key={i} fill={COLOR[x.v] || "#fce7f3"} />)}</Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
